import { Button, IconButton, Tooltip, withStyles } from "@material-ui/core";
import { DateTime } from "./ReceivingHours";
import { EventBusyOutlined } from "@material-ui/icons";
import capitalize from 'lodash/capitalize';


const styles = (theme) => ({
  disabledDefaultHours: {
    opacity: 0.4,
    pointerEvents: "none",
  },
  closeIcon: {
    "&:hover": {
      color: theme.error,
    },
    color: theme.iconColor,
  },
  timeRangeEditorStyle: {
    marginBottom: 10,
    marginLeft: -5,
  },
  defaultHours: {
    color: theme.ErrorMessageColor,
  },
});

const DayOfWeekHoursInput = ({
  hasHours,
  markDefaultHoursClosed,
  isDefaultHoursClosed,
  classes,
  defaultHoursError,
  addDayOfWeekHours,
  updateDefaultHours,
  defaultHours
}) => {
  return (
    <div className={hasHours ? classes.disabledDefaultHours : ""}>
      <div>
        {capitalize("Default hours")}
        {!isDefaultHoursClosed ? (
          <Tooltip title="Mark Permanently Closed">
            <IconButton
              onClick={markDefaultHoursClosed}
              classes={{ root: classes.closeIcon }}
            >
              <EventBusyOutlined />
            </IconButton>
          </Tooltip>
        ) : (
          <>
            <br />
            <br />
          </>
        )}
      </div>
      <div className={classes.timeRangeEditorStyle}>
        <DateTime
          time={defaultHours}
          updateTime={updateDefaultHours}
          isClosedDay={isDefaultHoursClosed}
          key={`closed_${isDefaultHoursClosed}`}
          autoFocus={!hasHours}
        />
        {defaultHoursError && (
          <div className={classes.defaultHours}>{defaultHoursError}</div>
        )}
      </div>
      {hasHours ? null : (
        <Button
          id="addDayOfWeekHours"
          // className={classes.addHoursStyle}
          color="primary"
          variant="text"
          onClick={addDayOfWeekHours}
          disabled={Boolean(defaultHoursError)}
        >
          + Add day of week hours
        </Button>
      )}
    </div>
  );
};

export default withStyles(styles)(DayOfWeekHoursInput);